export default __webpack_public_path__ + "static/media/VISA-logo.fd5b813f.png";